import http from "@/libs/http";
const game = {
  /**审批赛事 - 系统管理员、青少司 */
  gameApprove: ApproveVO => {
    return http.post(http.formatUrl("game/approve"), ApproveVO);
  },
  /**批量审批赛事 - 系统管理员、青少司 */
  gameApproveBatch: BatchApproveVO => {
    return http.post(http.formatUrl("game/approve/batch"), BatchApproveVO);
  },
  /**新建训练营 - 系统管理员、项目中心、省、操作员 */
  gameCampInsert: GameVO => {
    return http.post(http.formatUrl("game/camp/insert"), GameVO);
  },
  /**修改训练营 - 系统管理员、项目中心、省 、操作员 */
  gameCampUpdate: GameVO => {
    return http.post(http.formatUrl("game/camp/update"), GameVO);
  },
  /**删除赛事 - 系统管理员、项目中心、省 */
  gameDelete: GameId => {
    return http.post(http.formatUrl("game/delete"), GameId);
  },
  /**查询赛事详情 - 所有登录用户 */
  gameInfo: GameId => {
    return http.get(http.formatUrl("game/info"), GameId);
  },
  /**新建赛事 - 系统管理员、项目中心、省 */
  gameInsert: GameVO => {
    return http.post(http.formatUrl("game/insert"), GameVO);
  },
  /**查询赛事分页列表 - 所有登录用户 */
  gamePageList: GamePageListVO => {
    return http.get(http.formatUrl("game/pagelist"), GamePageListVO);
  },
  /**撤销已提交的赛事 - 系统管理员、项目中心、省 */
  gameRevoke: GameId => {
    return http.post(http.formatUrl("game/revoke"), GameId);
  },
  /**提交赛事 - 系统管理员、项目中心、省 */
  gameSubmit: GameId => {
    return http.post(http.formatUrl("game/submit"), GameId);
  },
  /**批量提交赛事 - 系统管理员、项目中心、省 */
  gameSubmitBatch: BatchGameId => {
    return http.post(http.formatUrl("game/submit/batch"), BatchGameId);
  },
  /**修改赛事 - 系统管理员、项目中心、省 */
  gameUpdate: GameVO => {
    return http.post(http.formatUrl("game/update"), GameVO);
  },
  /**查询分页列表 - 所有登录用户 */
  planOtherPageList: PlanOtherPageListVO => {
    return http.get(http.formatUrl("plan/other/pagelist"), PlanOtherPageListVO);
  },
  /**查询详情 - 所有登录用户 */
  planOtherInfo: GameId => {
    return http.get(http.formatUrl("plan/other/info"), GameId);
  },
  /**新建 - 系统管理员、项目中心、省、操作员 */
  planOtherInsert: PlanOtherVO => {
    return http.post(http.formatUrl("plan/other/insert"), PlanOtherVO);
  },
  /**修改 - 系统管理员、项目中心、省 、操作员 */
  planOtherUpdate: PlanOtherVO => {
    return http.post(http.formatUrl("plan/other/update"), PlanOtherVO);
  },
  /**审批 - 系统管理员、青少司 */
  planOtherApprove: ApproveVO => {
    return http.post(http.formatUrl("plan/other/approve"), ApproveVO);
  },
  /**批量审批 - 系统管理员、青少司 */
  planOtherApproveBatch: BatchApproveVO => {
    return http.post(http.formatUrl("plan/other/approve/batch"), BatchApproveVO);
  },
  /**删除 - 系统管理员、项目中心、省、操作员 */
  planOtherDelete: GameId => {
    return http.post(http.formatUrl("plan/other/delete"), GameId);
  },
  /**撤销已提交的 - 系统管理员、项目中心、省 */
  planOtherRevoke: GameId => {
    return http.post(http.formatUrl("plan/other/revoke"), GameId);
  },
  /**提交 - 系统管理员、项目中心、省 */
  planOtherSubmit: GameId => {
    return http.post(http.formatUrl("plan/other/submit"), GameId);
  },
  /**批量提交 - 系统管理员、项目中心、省 */
  planOtherSubmitBatch: BatchGameId => {
    return http.post(http.formatUrl("plan/other/submit/batch"), BatchGameId);
  },
  /**用户列表 */
  userListPage: PlanOtherPageListVO => {
    return http.get(http.formatUrl("user/list/page"), PlanOtherPageListVO);
  },
  /**获取类型计划需要用到的字典数据 - 所有登录用户 */
  planOtherItemDict: PlanOtherItemDictVO => {
    return http.get(http.formatUrl("plan/other/item/dict"), PlanOtherItemDictVO);
  }
};
export default game;
